import { environment } from '../config/environment';
import { useApiClient } from './api';
import {
    LivePrice,
} from './dashboard.types';
import { InsightData, InsightPeriod, InsightTrades, ShortLongData } from './insights.types';

export const useInsightsService = () => {
  const apiClient = useApiClient();

  const getShortLongPositions = async (date: string | null, period: InsightPeriod | null, trades: InsightTrades | null): Promise<ShortLongData> => {
    try {
      let url = `${environment.ctLiteApiUrl}/insights/short-long`;
      const params = [];
      if (date) params.push(`date=${date}`);
      if (period) params.push(`period=${period}`);
      if (trades) params.push(`trades=${trades}`);
      if (params.length > 0) url += `?${params.join('&')}`;
      
      const response = await apiClient.get<ShortLongData>(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching short/long positions:', error);
      throw error;
    }
  };


  const getGainsData = async (): Promise<InsightData[]> => {
    try {
        const response = await apiClient.get<InsightData[]>(`${environment.ctLiteApiUrl}/insights/gains`);
        return response.data;
    } catch (error) {
        console.error('Error fetching gains data:', error);
        throw error;
    }
};


const getCoinBalanceForAccount = async () => {
  try {
      const response = await apiClient.get<LivePrice[]>(
          `${environment.ctLiteApiUrl}/insights/account-coin-balance`
      );
      return response.data;
  } catch (error) {
      console.error(error);
      throw error;
  }
};

  return {
    getGainsData,
    getCoinBalanceForAccount,
    getShortLongPositions,
  };
};
